import React from "react";
import { useTranslation } from "react-i18next";

export function useLocationFormValidation(
    existingDesignationsSet: Set<string>,
    editedData: Place,
) {
    const { t } = useTranslation();

    const [inputDesignation, setInputDesignation] = React.useState(false);
    const [isNotInteger, setIsNotInteger] = React.useState(false);
    const [isDesignationExist, setIsDesignationExist] = React.useState(false);

    const editedId = editedData.Id;
    const editedDesignationValue = String(editedData[t("Designation")] ?? "").trim();

    const validateDesignation = React.useCallback(
        (value: string): { notInteger: boolean; duplicate: boolean } => {
            const trimmed = value.trim();
            const notInteger = trimmed !== "" && !/^\d+$/.test(trimmed);
            const duplicate =
                !notInteger &&
                trimmed !== "" &&
                existingDesignationsSet.has(trimmed.toLowerCase()) &&
                (editedId === undefined ||
                    editedDesignationValue !== trimmed);
            return { notInteger, duplicate };
        },
        [existingDesignationsSet, editedId, editedDesignationValue]
    );

    const hasError = inputDesignation || isNotInteger || isDesignationExist;

    return {
        inputDesignation,
        setInputDesignation,
        isNotInteger,
        setIsNotInteger,
        isDesignationExist,
        setIsDesignationExist,
        validateDesignation,
        hasError,
    };
}
